import { ROLES } from '@/constants'
// import services from '@/services'

export default {
  namespaced: true,
  state: {
    currentStore: null,
    currentRole: null
  },
  mutations: {
    setCurrentStore(state, store) {
      state.currentStore = store
    },
    setCurrentRole(state, role) {
      state.currentRole = role
    }
  },
  actions: {
    async setCurrentStore({ commit }, store) {
      // const { accessToken, refreshToken } = await services.stores.changeStore(
      //   store.id
      // )
      // commit('auth/setAccessToken', accessToken, { root: true })
      // commit('auth/setRefreshToken', refreshToken, { root: true })
      commit('setCurrentStore', store)
    }
  },
  getters: {
    hasCommissions(state) {
      return Boolean(state.currentStore?.hasCommissions)
    },
    hasRentSignature(state) {
      return Boolean(state.currentStore?.hasRentSignature)
    },
    hasDepositPhotos(state) {
      return Boolean(state.currentStore?.hasDepositPhotos)
    },
    isDepositPhotoRequired(state) {
      return Boolean(state.currentStore?.isDepositPhotoRequired)
    },
    hasCheckoutClosingNotebookPhotos(state) {
      return Boolean(state.currentStore?.hasCheckoutClosingNotebookPhotos)
    },
    isCheckoutClosingNotebookPhotoRequired(state) {
      return Boolean(state.currentStore?.isCheckoutClosingNotebookPhotoRequired)
    },
    hasCheckoutMachineReceiptPhotos(state) {
      return Boolean(state.currentStore?.hasCheckoutMachineReceiptPhotos)
    },
    isCheckoutMachineReceiptPhotoRequired(state) {
      return Boolean(state.currentStore?.isCheckoutMachineReceiptPhotoRequired)
    },
    isAdmin(state) {
      console.log(`currentRole in store.js:`)
      console.log(state)
      return state.currentRole === ROLES.ADMIN.value
    },
    isEmployer(state) {
      return state.currentRole === ROLES.EMPLOYER.value
    },
    isShopping(state) {
      return state.currentRole === ROLES.SHOPPING.value
    },
    isAdminFranchisee(state) {
      return state.currentRole === ROLES.ADMIN_FRANCHISEE.value
    },
    currentStoreId(state) {
      return state.currentStore?.id ?? null
    },
    isKiosk: (state) => state.currentRole === ROLES.KIOSK.value,
    isNotKiosk: (state) => state.currentRole !== ROLES.KIOSK.value
  }
}
